<template>
  <div>
    <div>
      <h2 class="h2 mb-0 bord" style="font-family: 'Recursive', sans-serif;" >Step 1 of 3</h2>
      <h1 class="h3 mb-2" style="font-family: 'Comfortaa', cursive;">Please watch the following videos before attempting the quiz.</h1>

      <div class="video-container">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/UnMXZakMxuI"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <h5 style="font-family: 'Comfortaa', cursive;">Ayurveda &amp; Covid-19</h5>
    </div>
    <div class="my-2">
      <button class="button mt-3 waves-effect waves-light orange lighten-3 black-text btn" v-on:click="quiz()">Proceed</button>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    quiz() {
      this.$router.push({ name: "viewVideos1" });
    },
  },
};
</script>
<style>
.bord{
  border-color: burlywood;
  border: burlywood;
  border-style: double;
  color:gold
}
</style>
